<template>
    <span :data-balloon="tooltip" data-balloon-pos="up">
        <i @click="open" class="fa fa-trash"></i>
        <div class="remodal" :data-remodal-id="modalID">
            <p>Are you sure you want to delete <strong>{{title}}</strong>? This action cannot be undone.</p>
            <button data-remodal-action="cancel" class="remodal-cancel simple">Cancel</button>
            <button data-remodal-action="confirm" class="remodal-confirm simple" @click="confirm">OK</button>
        </div>
    </span>
</template>

<script>
    import Modal from 'vue/common/_modal';

    export default {
        computed: {
            modalID() {
                return `${this.id}-delete`
            },
        },

        methods: {
            confirm() {
                this.$store.dispatch('submittalBrace/destroy', {id: this.id})
                    .then(() => {
                        window.location.reload();
                    });
            },
        },
        extends: Modal,

        props: {
            id: {
                type: [String, Number]
            },
            title: {
                type: String
            },
            url: {
                type: String
            },
            tooltip: {
                default: "Delete",
                type: String
            }
        }
    }
</script>
